import {
  jb_radio_css_default
} from "./chunk.XEMVJZOI.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  FormElement
} from "./chunk.YSL2HSIS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  e,
  n,
  r as r2,
  r2 as r3
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-radio/jb-radio.ts
var JbRadio = class extends Initiable(FormElement(r)) {
  constructor() {
    super(...arguments);
    this._index = 0;
  }
  async firstUpdated() {
    await this.updateComplete;
    if (this.value) {
      this._index = parseInt(this._selectedElement.dataset.index || "0", 10);
    }
  }
  _handleInputChange(e2) {
    this._index = parseInt(e2.target.dataset.index || "0", 10);
    this.value = e2.target.value;
  }
  _handleKeyDown(e2) {
    const optionElements = this._optionElements;
    switch (e2.code) {
      case "Space":
      case "Enter":
        e2.target.click();
        e2.preventDefault();
        break;
      case "ArrowLeft":
      case "ArrowUp":
        e2.preventDefault();
        this._index -= 1;
        if (this._index < 0) {
          this._index = this.options.length - 1;
        }
        optionElements[this._index].focus();
        optionElements[this._index].click();
        break;
      case "ArrowRight":
      case "ArrowDown":
        e2.preventDefault();
        this._index += 1;
        if (this._index >= this.options.length) {
          this._index = 0;
        }
        optionElements[this._index].focus();
        optionElements[this._index].click();
        break;
      case "Backspace":
      case "Delete":
        if (!this.requiredText) {
          const selectedOption = this.renderRoot.querySelector("input:checked");
          if (selectedOption) {
            this.value = "";
            selectedOption.checked = false;
            this._index = 0;
          }
        }
        break;
      default:
        break;
    }
  }
  render() {
    return ke`
      <div
        class="${Rt({ error: !!this.errorText || this.showError, disabled: !!this.disabled })}"
        data-fly-tweak="10,-10,20,0"
      >
        ${this.label ? ke`<label class="main">${this.label}${this.requiredText ? "*" : ""}</label>` : D}
        <div
          class="radios"
          role="radiogroup"
          aria-label="${this.label}"
          aria-invalid="${this.showError || this.errorText ? "true" : "false"}"
          aria-errormessage=${this.showError || !!this.errorText ? `${this.name}_error` : D}
          aria-required=${!!this.requiredText}
          @focusin=${() => {
      if (!this.value && this.requiredText) {
        this._optionElements[this._index].click();
      }
    }}
        >
          ${this.options.map(
      (option, index) => ke`
              <label>
                <input
                  data-index="${index}"
                  .value=${option.value}
                  type="radio"
                  name="${this.name}"
                  ?checked="${option.value === this.value}"
                  ?required=${!!this.requiredText}
                  ?disabled=${this.disabled}
                  @change=${this._handleInputChange}
                  aria-label="${option.label}"
                  aria-checked="${option.value === this.value}"
                />
                <p
                  tabindex="${this._index === index || option.value === this.value ? "0" : "-1"}"
                  @keydown=${this._handleKeyDown}
                >
                  ${option.label}
                </p>
              </label>
            `
    )}
        </div>
        <div
          aria-live="polite"
          id="${this.name}_error"
        >
          ${this.showError ? ke`<p class="error">${this.requiredText}</p>` : D}
          ${this.errorText ? ke`<p class="error">${this.errorText}</p>` : D}
        </div>
      </div>
    `;
  }
};
JbRadio.styles = [reset_css_default, jb_radio_css_default];
JbRadio.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Array })
], JbRadio.prototype, "options", 2);
__decorateClass([
  r2()
], JbRadio.prototype, "_index", 2);
__decorateClass([
  r3("label p")
], JbRadio.prototype, "_optionElements", 2);
__decorateClass([
  e("input:checked")
], JbRadio.prototype, "_selectedElement", 2);
JbRadio = __decorateClass([
  customElement("jb-radio")
], JbRadio);

export {
  JbRadio
};
